function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import ArticlesEditData from './ArticlesEditData.context';
import UploadFile from '../../common/assets/UploadFile.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Confirm from '../../common/modal/Confirm.modal';
import Checkbox from '../../common/form/Checkbox.react';

// TODO :: show file
var ArticleCareer = function ArticleCareer(_ref) {
  var showModalAction = _ref.showModalAction,
    articlesAction = _ref.articlesAction;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var articleID = state.articleID,
    articleType = state.articleType,
    careerArticle = state.careerArticle,
    archived = state.archived;
  if (articleType !== 'career') return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Attach Job Description",
    button: {
      label: careerArticle !== null && careerArticle !== void 0 && careerArticle.assetID ? 'Remove File' : 'Attach File',
      type: 'add',
      permission: 'edit-pos-articles',
      disabled: archived,
      onClick: function onClick() {
        if (careerArticle.assetID) {
          showModalAction({
            component: /*#__PURE__*/React.createElement(Confirm, {
              onConfirm: function onConfirm() {
                articlesAction({
                  formData: {
                    articleID: articleID
                  },
                  route: 'career',
                  method: 'delete'
                });
              }
            })
          });
        } else {
          showModalAction({
            component: /*#__PURE__*/React.createElement(UploadFile, {
              type: "document",
              onUploaded: function onUploaded(file) {
                articlesAction({
                  formData: {
                    articleID: articleID,
                    assetID: file._id,
                    filename: file.filename
                  },
                  route: 'career',
                  method: 'put'
                });
              }
            })
          });
        }
      }
    }
  }), careerArticle.assetID && /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      window.open("".concat(bucket, "/").concat(careerArticle.filename), '_blank');
    },
    style: {
      fontSize: 16,
      color: '#007bc2',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  }, "View Job Description")))), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Application"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Checkbox, {
    label: "Allow application",
    checked: careerArticle === null || careerArticle === void 0 ? void 0 : careerArticle.showApplyLink,
    onChange: function onChange(val) {
      articlesAction({
        formData: {
          articleID: articleID,
          value: val
        },
        route: 'career-apply',
        method: 'put'
      });
    }
  })))));
};
var mdtp = {
  showModalAction: modalActions.show,
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticleCareer);